import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  ShoppingCart,
  X,
  PackageIcon,
  UserCog,
  BookCheck,
  Book,
  TagIcon,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import logoSrc1 from '../../../src/assets/logo.png';
const Sidebar = ({ closeSidebar }) => {
  const { viewType } = useSelector((state) => state.userInfo);

  const brandNavItems = [
    {
      name: 'Product Management',
      path: '/brand/products',
      icon: <PackageIcon size={20} />,
    },
    {
      name: 'Seller Details',
      path: '/brand/sellers',
      icon: <UserCog size={20} />,
    },
    {
      name: 'Dashboard',
      path: '/brand/dashboard',
      icon: <LayoutDashboard size={20} />,
      disabled: true,
    },
    // {
    //   name: 'History',
    //   path: '/brand/history',
    //   icon: <History size={20} />,
    //   disabled: false,
    // },
  ];

  const sellerNavItems = [
    {
      name: 'Brand Catalog',
      path: '/seller/brand-catalog',
      icon: <BookCheck size={20} />,
    },
    { name: 'My Catalog', path: '/seller/catalog', icon: <Book size={20} /> },
    {
      name: 'Dashboard',
      path: '/seller/dashboard',
      icon: <LayoutDashboard size={20} />,
      disabled: true,
    },
    {
      name: 'Orders',
      path: '/seller/orders',
      icon: <ShoppingCart size={20} />,
      disabled: false,
    },
    {
      name: 'Price Logs',
      path: '/seller/price-log',
      icon: <TagIcon size={20} />,
      disabled: false,
    },
  ];

  let navItems = [];
  if (viewType === 'brand') {
    navItems = brandNavItems;
  } else if (viewType === 'seller') {
    navItems = sellerNavItems;
  }

  return (
    <div className="flex flex-col h-full secondary-background border-r border-gray-200">
      <div className="flex items-center justify-between px-4 h-16 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className=" flex items-center">
            <img src={logoSrc1} alt="logoAlt1" className="w-[145px] h-[130px]" />
          </div>
          <span className="ml-1 px-2 py-1 text-xs font-medium primary-background white-text rounded">
            {viewType}
          </span>
        </div>
        <button
          className="md:hidden rounded-md p-2 text-secondary hover:text-gray-600 hover:bg-gray-100"
          onClick={closeSidebar}
        >
          <X size={20} />
        </button>
      </div>

      <div className="flex-1 pt-5 pb-4">
        <nav className="px-2 space-y-1">
          {navItems.map((item) => (
            <div key={item.path}>
              {item.disabled ? (
                <div className="flex items-center px-3 py-3 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed relative group">
                  <span className="mr-3 text-gray-400">{item.icon}</span>
                  {item.name}
                  <span
                    className="absolute left-[50%] top-1/2 -translate-y-1/2 ml-2 primary-background white-text text-xs rounded px-2 py-1 
                               opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 
                               transition-all duration-300 ease-in-out whitespace-nowrap"
                  >
                    Coming Soon
                  </span>
                </div>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive, isPending }) =>
                    `flex items-center px-3 py-3 text-sm font-medium rounded-lg transition-colors ${
                      // eslint-disable-next-line no-restricted-globals
                      location.pathname.startsWith(item.path)
                        ? 'primary-background white-text'
                        : 'text-primary hover:bg-[#FC80190F]'
                    }`
                  }
                  onClick={closeSidebar}
                >
                  <span className="mr-3">{item.icon}</span>
                  {item.name}
                </NavLink>
              )}

              {item.subItems && (
                <div className="ml-6 mt-1 space-y-1">
                  {item.subItems.map((subItem) => (
                    <NavLink
                      key={subItem.name}
                      to={subItem.path}
                      className={({ isActive }) =>
                        `flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                          isActive
                            ? 'primary-background text-primary'
                            : 'white-text hover:bg-gray-100'
                        }`
                      }
                      onClick={closeSidebar}
                    >
                      {subItem.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
